import type { TestGroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { motion } from 'framer-motion'
import lodash from 'lodash'
import { useContext } from 'use-context-selector'

import { getObjectFitDivMap } from 'components/Editor/EditorElements/utils/getObjectFitDivMap'
import { RichTextViewer } from 'components/form/RichText/RichTextViewer'
import { useUrlByUsage } from 'utils/files'

import TestGroupingContext from '../../TestGroupingContext'
import * as s from './ScaledAnswer.module.scss'

interface IScaledAnswerProps {
  item: TestGroupingItem
  onAnimationComplete?: () => void
}

const ScaledAnswer = ({ item, onAnimationComplete }: IScaledAnswerProps) => {
  const { styles, font } = useContext(TestGroupingContext)
  const url = useUrlByUsage(item.image, FileUsageTypeEnum.image)

  return (
    <motion.div
      animate={{
        scale: 0,
        opacity: 0,
      }}
      className={s.item}
      exit={{
        scale: 0,
        opacity: 0,
      }}
      initial={{
        scale: 1,
        opacity: 1,
      }}
      onAnimationComplete={onAnimationComplete}
      style={{
        ...lodash.omit(styles.answer, ['borderColor', 'borderWidth', 'borderStyle']),
        ...styles.common,
        backgroundImage: url && `url(${url})`,
        backgroundSize: getObjectFitDivMap(item.image?.objectFit),
      }}
      transition={{
        stiffness: 100,
        damping: 25,
        mass: 0.8,
        type: 'spring',
      }}
    >
      <div
        className={s.mask}
        style={{
          backgroundColor: styles.answer.backgroundColor,
          borderRadius: styles.common.borderRadius,
        }}
      />
      <div className={s.label} style={{ justifyContent: styles.answer.alignItems }}>
        <div className={s.textInner} style={font?.base}>
          <RichTextViewer styles={font} value={item.label} />
        </div>
      </div>
    </motion.div>
  )
}

export default ScaledAnswer
